import { useEffect, useState } from 'react';
import { Alert, Spin, Tag } from 'antd';
import { cameraCalibrations, video } from '../../services/api';
import EzvizPlayer from '../../components/EzvizPlayer';

export default function StationVideoFusion({ spaceId }) {
  const [cameras, setCameras] = useState([]);
  const [cameraId, setCameraId] = useState(null);
  const [calibration, setCalibration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    video.list().then(res => {
      if (cancelled) return;
      const list = (res.data || []).filter(item => item.space_id === spaceId && item.is_active !== false);
      setCameras(list);
      setCameraId(list.find(item => item.channel_no === 25)?.id || list[0]?.id || null);
      if (!list.length) setLoading(false);
    }).catch(err => {
      if (!cancelled) {
        setError(err.message || '摄像头加载失败');
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, [spaceId]);

  useEffect(() => {
    if (!cameraId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    setCalibration(null);
    cameraCalibrations.get(cameraId).then(res => {
      if (!cancelled) setCalibration(res.data.calibration);
    }).catch(err => {
      if (!cancelled) setError(err.response?.data?.message || err.message || '标定参数加载失败');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [cameraId]);

  const camera = cameras.find(item => item.id === cameraId);
  const verified = calibration?.status === 'verified' && calibration?.extrinsic_json;

  return (
    <div className="bs-video-fusion">
      <div className="bs-fusion-toolbar">
        <select
          className="bs-station-select" value={cameraId || ''}
          onChange={event => setCameraId(Number(event.target.value))}
          aria-label="融合监控通道"
        >
          {cameras.map(item => <option key={item.id} value={item.id}>{item.name}（通道{item.channel_no}）</option>)}
        </select>
        {verified ? (
          <>
            <Tag color="green">空间标定已验收</Tag>
            <span>RMS {Number(calibration.reprojection_rms).toFixed(3)} px</span>
            <span>标定时间 {calibration.calibrated_at ? new Date(calibration.calibrated_at).toLocaleString('zh-CN', { hour12: false }) : '-'}</span>
          </>
        ) : <Tag color="orange">待完成真实标定</Tag>}
      </div>
      <div className="bs-fusion-stage">
        {loading && <Spin tip="正在读取标定参数" />}
        {error && <Alert type="warning" showIcon message="无法进入虚实融合" description={error} />}
        {!loading && !error && camera && !verified && (
          <Alert
            type="info" showIcon message="该通道尚未达到融合条件"
            description="请先在“视频融合标定”中采集真实对应点，完成PnP计算并达到RMS≤1像素。系统不会用估计位姿生成虚假对齐画面。"
          />
        )}
        {!loading && !error && camera && verified && (
          <>
            <div className="bs-fusion-video"><EzvizPlayer camera={camera} /></div>
            <iframe
              key={camera.id} className="bs-fusion-twin"
              src={`/twin/yushe/cesium.html?fusion=${camera.id}`}
              title={`${camera.name}三维信息层`} allow="fullscreen"
            />
          </>
        )}
      </div>
    </div>
  );
}
